export default "__VITE_ASSET__ClhNEwKy__"